import { RemoveScrollSideCar } from "./auth-service-tools1001.js";
import { effectCar } from "./auth-service-tools999.js";
import { exportSidecar } from "./auth-service-tools1002.js";
const SideCar = exportSidecar(effectCar, RemoveScrollSideCar);
export { SideCar as default };